import { UserCreateRequest, UserDto } from "dto/user-dto";
import { BaseCrudService } from "./baseCrudService";

class UserService extends BaseCrudService<UserDto> {
  constructor() {
    super("/api/v1/users");
  }
}

export const userService = new UserService();